import { Err, IConversation, IGroup, IPost, IUser, Ok, Result } from '@/classes'

export const groupAnnounceAPI = async (groupId: string) => {
	const response: Result<{ success: boolean }> = await fetchAPI('group/announce', { groupId })
	if (!response.ok) return response as Err

	return {
		ok: true,
		data: response.data
	} as Ok<{ success: boolean }>
}

export const groupJoinAPI = async (
	_id: string,
	params?: {
		intro?: string
	}
) => {
	const response: Result<{ group: IGroup, status: string }> = await fetchAPI('group/join', { group: _id, ...(params ?? {}) }, { method: 'POST' })

	if (!response.ok) return response as Err

	return {
		ok: true,
		data: response.data
	} as Ok<{ group: IGroup, status: string }>
}

export const groupRequestAnswerAPI = async (
	groupId: string,
	userId: string,
	action: 'accept' | 'decline'
) => {
	const response: Result<{ group: IGroup, status: string }> = await fetchAPI('group/request', { groupId, userId, action }, { method: 'POST' })

	if (!response.ok) return response as Err

	return {
		ok: true,
		data: response.data
	} as Ok<{ group: IGroup, status: string }>
}

export const groupRolesSetAPI = async (
	userId: string, 
	role: 'admin' | 'organizer' | 'member',
	groupId: string
) => {
	const response: Result<{ group: IGroup }> = await fetchAPI('group/roles', { groupId, userId, role }, { method: 'POST' })

	if (!response.ok) return response

	return response
}

export const groupKickAPI = async (
	userId: string,
	groupId: string
) => {
	const response: Result<{ group: IGroup }> = await fetchAPI('group/kick', { groupId, userId }, { method: 'POST' })

	if (!response.ok) return response

	return response
}

export const groupRolesTransferAPI = async (
	groupId: string
) => {
	const response: Result<{ group: IGroup }> = await fetchAPI('group/roles/transfer', { groupId }, { method: 'POST' })

	if (!response.ok) return response

	return response
}

export const groupsGetOneAPI = async (
	_id: string,
	params?: {
		slug?: string
		token?: string
	}
) => {
	const response: Result<{ group: IGroup | null, conversations: IConversation[], posts: IPost[], users: IUser[] }> = await fetchAPI('group/one', { _id, slug: params?.slug, params }, { method: 'POST', })

	if (!response.ok) return response

	return response
}

export const groupsGetMineAPI = async () => {
	const response: Result<{ groups: IGroup[], unread: { _id: string, unread: number }[] }> = await fetchAPI('group/mine', {}, { method: 'POST', })

	return response
}

export const groupsUsersGetAPI = async (
	params: {
		groupId: string,
		options: FetchOptions
	},
	controller: AbortController
) => {
	const response: Result<{ users: IUser[] }> = await fetchAPI('group/users', params, { method: 'POST', controller })

	if (!response.ok) return response

	return response
}

export const groupsListGetAPI = async (
	filters: {

	},
	options: FetchOptions,
	controller?: AbortController
) => {
	const response: Result<{ groups: IGroup[], groupsMine: IGroup[] }> = await fetchAPI('groups/list', { filters, options}, { method: 'POST', controller })

	if (!response.ok) return response

	return response
}

export const groupsGetSuggestedAPI = async (
	filters: {
		categories?: string[]
	},
	options: FetchOptions,
	controller?: AbortController
) => {
	const response: Result<{ categories: { label: string, emoji: string, value: string, groups: IGroup[] }[] }> = await fetchAPI('groups/suggested', { filters, options }, { method: 'POST', controller })

	return response
}

export const groupConversationCreateAPI = async (
	groupId: string,
	options?: {
		name?: string
	}
) => {
	const response: Result<{ conversation: IConversation | null, group: IGroup | null }> = await fetchAPI('group/conversation', { groupId, options }, { method: 'POST' })

	return response
}